import { render, staticRenderFns } from "./ProfileUpdateSuccess.vue?vue&type=template&id=103d7b5b"
import script from "./ProfileUpdateSuccess.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports